"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DenyContainer = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Button = require("../../../../Button");
var _templateObject;
var DenyContainer = exports.DenyContainer = (0, _styledComponents["default"])(_Button.Button)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  width: 59px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px 12px;\n  font-size: 14px;\n  line-height: 16px;\n"])));